const steps = [
    {
        n: "01",
        title: "Book a slot",
        body: "Pick a service, date and time. Get a flat-rate quote upfront — no surprises after.",
    },
    {
        n: "02",
        title: "We come to you",
        body: "Your mechanic arrives at your driveway, parking lot or roadside. ETA is shared by SMS.",
    },
    {
        n: "03",
        title: "Fixed on-site",
        body: "Repair completed in front of you. You get a digital invoice when the work is done.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="process"
            data-testid="how-it-works-section"
            className="border-b hairline bg-[#fdfdfd]"
        >
            <div className="mx-auto max-w-[1400px]">
                <div className="px-6 md:px-12 py-12 border-b hairline flex items-end justify-between flex-wrap gap-4">
                    <div>
                        <div className="font-mono-tech text-[11px] text-[#1d4ed8] mb-3">
                            HOW IT WORKS
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl tracking-tighter">
                            Three steps. Zero hassle.
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3">
                    {steps.map((s) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${s.n}`}
                            className="border-r hairline last:border-r-0 p-8 md:p-12"
                        >
                            <div className="font-display text-[96px] md:text-[140px] leading-none text-[#0a0a0a] mb-6">
                                {s.n}
                            </div>
                            <div className="font-mono-tech text-[10px] text-[#52525b] mb-4">
                                STEP / {s.n}
                            </div>
                            <h3 className="font-display text-2xl mb-3">
                                {s.title}
                            </h3>
                            <p className="text-[#52525b] leading-relaxed">
                                {s.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
